import { withStyles } from "@material-ui/core";
import Tooltip from "../../../../../common/StyledToolTip";
import { getCombinedIcons } from "../../../../../dataGrid/cellRenderer/SpecialNeedsRenderer";
import { getSvgIcons } from "../../../../../modules/Dispatch/utils/svgIcons";

const styles = {
  iconsContainer: {
    height: "100%",
    display: "table",
    float: "right",
  },
  iconStyle: {
    verticalAlign: "middle",
    display: "table-cell",
  },
};

const SpecialNeeds = ({ classes, stopData, values, specialNeeds }) => {
  const iconsList = getCombinedIcons(
    {
      value: values,
      data: stopData,
    },
    specialNeeds
  );
  const getIcon = (icons) => {
    if (icons.isSvgIcon) {
      return getSvgIcons(icons.icon);
    }
    return <i className={`${icons.icon}`} />;
  };
  return (
    <div className={classes.iconsContainer}>
      {iconsList.map((icons, index) => (
        <Tooltip key={index} title={icons.tooltip}>
          <div className={classes.iconStyle}>{getIcon(icons)}</div>
        </Tooltip>
      ))}
    </div>
  );
};

export default withStyles(styles)(SpecialNeeds);
